import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_COURSE_TYPE_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateCourseTypeImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_COURSE_TYPE_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateCourseTypeImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.cuisineTypes.cuisineType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_COURSE_TYPE_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateCourseTypeImageDetailsArgs(data) },
        dispatch,
        UPDATE_COURSE_TYPE_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateCourseTypeImageDetailsMutation
